"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SVGIconWithSizes = exports.SVGIcon = exports.IconSize = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var IconSize;
exports.IconSize = IconSize;

(function (IconSize) {
  IconSize[IconSize["ExtraSmall"] = 16] = "ExtraSmall";
  IconSize[IconSize["Small"] = 20] = "Small";
  IconSize[IconSize["Medium"] = 24] = "Medium";
  IconSize[IconSize["Large"] = 32] = "Large";
})(IconSize || (exports.IconSize = IconSize = {}));

var SVGDimensions = /*#__PURE__*/(0, _createClass2.default)(function SVGDimensions(height, width) {
  (0, _classCallCheck2.default)(this, SVGDimensions);
  (0, _defineProperty2.default)(this, "height", void 0);
  (0, _defineProperty2.default)(this, "width", void 0);
  this.height = height;
  this.width = width;
});

var SVGIcon = /*#__PURE__*/function (_SVGDimensions) {
  (0, _inherits2.default)(SVGIcon, _SVGDimensions);

  var _super = _createSuper(SVGIcon);

  function SVGIcon(paths, params, height, width) {
    var _this;

    (0, _classCallCheck2.default)(this, SVGIcon);
    _this = _super.call(this, height, width);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "kind", 'SVGIcon');
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "paths", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "params", void 0);
    _this.paths = paths;
    _this.params = params;
    return _this;
  }

  (0, _createClass2.default)(SVGIcon, [{
    key: "getAttributes",
    value: function getAttributes() {
      return {
        height: this.height,
        width: this.width,
        paths: this.paths,
        params: this.params
      };
    }
  }]);
  return SVGIcon;
}(SVGDimensions);

exports.SVGIcon = SVGIcon;

var SVGIconWithSizes = /*#__PURE__*/function () {
  function SVGIconWithSizes(data) {
    (0, _classCallCheck2.default)(this, SVGIconWithSizes);
    (0, _defineProperty2.default)(this, "kind", 'SVGIconWithSizes');
    (0, _defineProperty2.default)(this, "data", void 0);
    this.data = data;
  }

  (0, _createClass2.default)(SVGIconWithSizes, [{
    key: "getAttributes",
    value: function getAttributes(size) {
      var iconAvailableSizes = Object.keys(this.data);
      var fallbackSize = iconAvailableSizes.includes("".concat(IconSize.Small)) ? IconSize.Small : iconAvailableSizes[0];
      var selectedSize = iconAvailableSizes.includes("".concat(size)) ? size : fallbackSize;
      return this.data[selectedSize];
    }
  }]);
  return SVGIconWithSizes;
}();

exports.SVGIconWithSizes = SVGIconWithSizes;